import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckNoBorder = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 11,
	viewBox: "0 0 16 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M15 2.03125C15.3125 1.75 15.3125 1.28125 15 1C14.7188 0.6875 14.25 0.6875 13.9688 1L6 8.96875L2 5C1.71875 4.6875 1.25 4.6875 0.96875 5C0.65625 5.28125 0.65625 5.75 0.96875 6.03125L5.46875 10.5312C5.59375 10.6875 5.78125 10.75 6 10.75C6.1875 10.75 6.375 10.6875 6.5 10.5312L15 2.03125Z",
		fill: "#6200EA"
	})]
});
const ForwardRef = forwardRef(SvgCheckNoBorder);
export { ForwardRef as ReactComponent };
